export const messages = {
  en: {
    examineProjectManage: {
      search: {
        title: 'Search Conditions',
        namePlaceholder: 'Please enter project name',
        postPlaceholder: 'Please enter post',
        statePlaceholder: 'Please select status'
      },
      list: {
        title: 'Examination Projects'
      },
      table: {
        name: 'Project Name',
        post: 'Post',
        weight: 'Weight',
        state: 'Status'
      },
      form: {
        name: 'Project Name',
        namePlaceholder: 'Required, please enter project name',
        post: 'Post',
        postPlaceholder: 'Required, please select post',
        commonPost: 'Common Post',
        weight: 'Weight',
        weightPlaceholder: 'Required, please enter weight',
        state: 'Status',
        statePlaceholder: 'Required, please select status'
      },
      status: {
        enable: 'Enable',
        disable: 'Disable'
      },
      validate: {
        idRequired: 'ID is required',
        nameRequired: 'Project name is required',
        nameMaxLength: 'Project name cannot exceed 64 characters',
        postRequired: 'Post is required',
        postMaxLength: 'Post cannot exceed 30 characters',
        weightRequired: 'Weight is required',
        weightMaxLength: 'Weight cannot exceed 12 characters',
        stateRequired: 'Status is required',
        stateMaxLength: 'Status cannot exceed 12 characters'
      },
      add: {
        title: 'Add Examination Project',
        success: 'Added successfully',
        error: 'Failed to add'
      },
      edit: {
        title: 'Edit Examination Project',
        success: 'Updated successfully',
        error: 'Failed to update'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmText: 'Are you sure to delete this examination project?',
        success: 'Deleted successfully',
        error: 'Failed to delete'
      },
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    examineProjectManage: {
      search: {
        title: '查询条件',
        namePlaceholder: '请输入项目名称',
        postPlaceholder: '请输入岗位',
        statePlaceholder: '请选择状态'
      },
      list: {
        title: '考核项目'
      },
      table: {
        name: '项目名称',
        post: '岗位',
        weight: '比重',
        state: '状态'
      },
      form: {
        name: '项目名称',
        namePlaceholder: '必填，请填写项目名称',
        post: '岗位',
        postPlaceholder: '必填，请选择岗位',
        commonPost: '通用岗位',
        weight: '比重',
        weightPlaceholder: '必填，请填写比重',
        state: '状态',
        statePlaceholder: '必填，请选择状态'
      },
      status: {
        enable: '启用',
        disable: '停用'
      },
      validate: {
        idRequired: '编号不能为空',
        nameRequired: '项目名称不能为空',
        nameMaxLength: '项目名称不能超过64个字符',
        postRequired: '岗位不能为空',
        postMaxLength: '岗位编号不能超过30个字符',
        weightRequired: '比重不能为空',
        weightMaxLength: '比重不能超过12个字符',
        stateRequired: '状态不能为空',
        stateMaxLength: '状态不能超过12个字符'
      },
      add: {
        title: '添加考核项目',
        success: '添加成功',
        error: '添加失败'
      },
      edit: {
        title: '修改考核项目',
        success: '修改成功',
        error: '修改失败'
      },
      delete: {
        title: '删除确认',
        confirmText: '确定删除该考核项目吗？',
        success: '删除成功',
        error: '删除失败'
      },
      fetchError: '获取数据失败'
    }
  }
}